import script from "./I18nMessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./I18nMessageModal.vue?vue&type=script&setup=true&lang=js"

import "./I18nMessageModal.vue?vue&type=style&index=0&id=ab101c88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab101c88"]])

export default __exports__